export const OK = 200;
export const NOT_FOUND = 404;
export const LIMITED = 412;
export const INTERNAL_SERVER_ERROR = 500;
export const SERVICE_UNAVAILABLE_ERROR = 503;
